import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { MainButton } from '../../../inputs/buttons/MainButton';
import ModalContainer from '../../containers/ModalContainer';

// Styled Components
import { Container, ContainerText, Title, Text } from './styles';

// Types
import { ModalProps } from './types';
import { useTheme } from 'styled-components';

export const ChangeCampaignToOT = ({
  onClickClose,
  continueClick,
  ...props
}: ModalProps): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation('modals');
  return (
    <ModalContainer width={50} fill={theme.colors.black} onClickClose={onClickClose}>
      <Container {...props}>
        <ContainerText>
          <Title variant="semiBold">{t('changeCampaign.title')}</Title>
          <Text>{t('changeCampaign.description')}</Text>
        </ContainerText>
        <MainButton
          text={t('common:buttons.continue')}
          onClick={continueClick}
        />
      </Container>
    </ModalContainer>
  );
};
